/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import {
  Announcement,
  LIST_NAME as Announcementslist,
  LIST_NAME,
} from '../../../../assets/ts/data/announcements'
import { getBlobStorage } from '../../../../assets/ts/data/data'
import { openFile } from '../../../../assets/ts/files/files'
import { DocumentIconNames, filterBy } from '../../../../assets/ts/general/general'
import Accordions from '../../../../components/accordions/accordions'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import useAnnouncements from '../../../../hooks/use-announcements'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import {
  MetadataContext,
} from '../../../../store/metadata-context-provider'
import { ALL_SELECT_OPTION, ALL_SELECT_OPTION_STRING } from '../../../../utils/constants/global-constants'
import NO_RESULTS from '../../../../utils/constants/no-results'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import { optionsTypes } from '../../../../utils/controls/select-options-data'
import AddEditView from './add-edit-view'

interface Attachment {
  blobs: []
  itemKey: string
}
interface Accordions {
  AssignedComponent: string
  AssignedComponentCode: number
  Attachments?: Attachment[]
  Category?: string
  CategoryCode?: number
  Description: string
  ExpirationDate?: string
  Id: string
  IsArchived?: string
  MAJCOM: string
  MAJCOMCode: number
  Section: string
  SectionCode: number
  ServicingOrganization?: string // Added property
  Tags: string
  Title: string
  eKey: string
  eTag: string
}
let clickedItem: Accordions

const SettingsAnnouncements = ({
  assignedComponentOptions,
  initialMajcomOptions,
  initialSectionOptions,
  initialSquadronOptions,
  roleContext,
  visibleSquadrons
}: any) => {
  const { categories, components, majcoms, sections } = useContext(MetadataContext)

  const [refresh, setRefresh] = useState(false)
  const [showAddPopup, setShowAddPopup] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [showPageOverlay, setShowPageOverlay] = useState(false)

  const [accordionItems, setAccordionItems] = useState<Array<Accordions>>([])
  const [announcements, setAnnouncements] = useState<Announcement[]>([])
  const [filterAccordionItems, setFilterAccordionItems] = useState<Array<Accordions>>([])

  const [sectionOptions, setSectionOptions] = useState<any[]>(initialSectionOptions)
  const [majcomOptions, setMajcomOptions] = useState<any[]>(initialMajcomOptions)
  const [squadronOptions, setSquadronOptions] = useState<any[]>(initialSquadronOptions)

  const { AnnouncementData } = useAnnouncements({ isArchived: null })

  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })
  const [dropdownValues, setDropdownValues] = useState({
    assignComponent: -1 || '',
    majcom: -1 || '',
    section: -1 || '',
    squadron: '',
  })

  const assignComponents = components

  function addEditValue(showAddPopup: any) {
    setShowAddPopup(showAddPopup)
  }
  const onEdit = (item: any) => {
    setShowAddPopup(false)
    setInEditMode({
      rowKey: item?.Id,
      status: true,
    })
    setShowEdit(!showEdit)
  }
  const onDelete = async (item: any) => {
    clickedItem = item

    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setShowAlert(true)
  }
  async function deleteItem() {
    const lists = await mpfRListsHttp().getList(LIST_NAME)
    await lists.deleteItem(clickedItem.eKey, clickedItem.eTag)
    const newAnnouncements = announcements.filter((ann) => ann.eKey !== clickedItem.eKey)
    setAnnouncements(newAnnouncements)
    setRefresh(true)
  }
  const onClickAlert = async (button: string) => {
    if (button === 'OK') {
      setShowAlert(false)
      await deleteItem()
    } else {
      setShowAlert(false)
    }
  }
  const onAccordions = (item: any) => {
    setShowAddPopup(false)
    setInEditMode({
      rowKey: item.Id,
      status: false,
    })
    setAccordionItems(accordionItems)
  }
  const onCancel = () => {
    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setShowEdit(!showEdit)
  }
  function showEditPopup(ele: any) {
    // setShowEdit(ele)
  }
  function newAccordions(
    assignComponenet: number,
    majcom: number | string,
    section: number | string,
    squadron: string,
    items?: Accordions[]
  ) {
    const accordions = items ? items : accordionItems
    const newAccordion = accordions.filter((item) => {
      const servOrg = Array.isArray(squadron)
        ? squadron.map((squad) => squad === item.ServicingOrganization)[0]
        : item.ServicingOrganization === squadron
      return (
        filterBy(item.AssignedComponentCode, assignComponenet) &&
        filterBy(item.ServicingMAJCOMCode, majcom) &&
        (section === -1 || item.SectionCodes?.some((val) => val === section)) &&
        ( squadron === '' || servOrg)
      )
    })
    setFilterAccordionItems(newAccordion)
  }
  function onAssignComponentChange(e: { label: string; value: number }) {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === e.value || e.value === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => maj.squadron.includes(e.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })
      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions: any = [
      ...majOptions.filter((majcom) => majcom.squadron).map((majcom) => ({
        label: majcom.squadron,
        value: majcom.squadron
      }))
    ]

    let majcomValue: any = ALL_SELECT_OPTION.value
    let sectionValue: any = ALL_SELECT_OPTION.value
    let squadronValue: any = ALL_SELECT_OPTION_STRING.value

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    } else if (majOptions.length === 1) {
      majcomValue = majOptions[0].value
    }

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    } else if (squadOptions.length === 1) {
      squadronValue = squadOptions[0].value
    }

    setDropdownValues((prevState) => ({
      ...prevState,
      assignComponent: e.value,
      majcom: majcomValue,
      section: sectionValue,
      squadron: squadronValue,
    }))

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)
    newAccordions(e.value, majcomValue, sectionValue, squadronValue)
  }

  function onMajcomChange(e) {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (e.squadron.includes(sect.squadron) || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions: any = [
      ...majcomOptions.filter((majcom) => majcom.squadron).map((majcom) => ({
        label: majcom.squadron,
        value: majcom.squadron
      }))
    ]

    let sectionValue: any = ALL_SELECT_OPTION.value
    let squadronValue: any = ALL_SELECT_OPTION_STRING.value

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    } else if (sectOptions.length === 1) {
      squadronValue = squadOptions[0].value
    }

    setDropdownValues((prevState) => ({
      ...prevState,
      majcom: e.value,
      section: sectionValue,
      squadron: squadronValue,
    }))

    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)
    newAccordions(dropdownValues.assignComponent, e.value, sectionValue, squadronValue)
  }
  function onSectionChange(e: { label: string; value: number }) {
    setDropdownValues((prevState) => ({
      ...prevState,
      section: e.value,
    }))
    newAccordions(dropdownValues.assignComponent, 
      dropdownValues.majcom, e.value, dropdownValues.squadron)
  }

  function onSquadronChange(e: { label: string; value: number }) {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
                (sect.squadron === e.value || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    let sectionValue: any = ALL_SELECT_OPTION.value

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    } else if (sectOptions.length === 1) {
      sectionValue = sectOptions[0].value
    }


    setDropdownValues((prevState) => ({
      ...prevState,
      section: sectionValue,
      squadron: e.value,
    }))
    newAccordions(
      dropdownValues.assignComponent, 
      dropdownValues.majcom, 
      sectionValue, 
      e.value)
  }

  function onAdd() {
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setShowAddPopup(!showAddPopup)
  }
  function accordionContent(announcement: any, clickedIndex: any, index: any) {
    return (
      <div>
        {inEditMode?.rowKey === announcement?.Id ? (
          <AddEditView
            addOrEdit='Edit'
            announcement={announcement}
            announcements={announcements}
            assignComponents={assignComponents}
            assignedComponentOptions={assignedComponentOptions}
            cancel={onCancel}
            categories={categories}
            clickedIndex={index}
            initialMajcomOptions={initialMajcomOptions}
            initialSectionOptions={initialSectionOptions}
            initialSquadronOptions={initialSquadronOptions}
            majcoms={majcoms}
            refresh={refresh}
            roleContext={roleContext}
            sectionOption={sectionOptions}
            sections={sections}
            setAnnouncements={setAnnouncements}
            setRefresh={setRefresh}
            showAddPopup={showAddPopup}
            showEdit={showEdit}
            visibleSquadrons={visibleSquadrons}
          />
        ) : (
          announcement?.Id === clickedIndex && (
            <>
              <div
                aria-live='polite'
                className='my-2 pb-2 border-bottom1 d-flex flex-column p-2'
                tabIndex={0}
              >
                <span className='poppins-medium font-12 title-color2 pb-1'>Description</span>
                <span className='poppins-medium font-12 subtitle-color1 pb-1 lh-normal'>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: announcement?.Description,
                    }}
                  ></span>
                </span>
              </div>
              <div aria-live='polite' className='d-flex flex-column p-2' tabIndex={0}>
                <span className='poppins-medium font-12 title-color2 pb-1'>Attachments</span>
                <ul>
                  <li>
                    {announcement?.Attachments[0]?.blobs.length > 0 &&
                      announcement.Attachments[0].blobs.map((blob) => (
                        <a
                          className='color-primary poppins-medium font-12 text-capitalize maxfitcontent'
                          href='#'
                          key={blob.fileName}
                          onClick={() => openFile(blob, announcement.eKey, LIST_NAME)}
                          tabIndex={0}
                          title={blob.fileName}
                        >
                          <span className='color-primary'>
                            <span className={`${DocumentIconNames(blob.fileName)} pe-2`}></span>
                            {blob.fileName}
                          </span>
                        </a>
                      ))}
                  </li>
                </ul>
              </div>
            </>
          )
        )}
      </div>
    )
  }

  useEffect(() => {
    setMajcomOptions(initialMajcomOptions)
    setSectionOptions(initialSectionOptions)
    setSquadronOptions(initialSquadronOptions)
  }, [initialMajcomOptions, initialSectionOptions, initialSquadronOptions])

  useEffect(() => {
    let majcomValue = ALL_SELECT_OPTION.value
    let assigneComponentValue = ALL_SELECT_OPTION.value
    let sectionValue = ALL_SELECT_OPTION.value
    let squadronValue = ALL_SELECT_OPTION_STRING.value

    if (initialMajcomOptions.length === 1) {
      majcomValue = initialMajcomOptions[0].value
    }

    if (assignedComponentOptions.length === 1) {
      assigneComponentValue = assignedComponentOptions[0].value
    }

    if (initialSectionOptions.length === 1) {
      sectionValue = initialSectionOptions[0].value
    }

    if (initialSquadronOptions.length === 1) {
      squadronValue = initialSquadronOptions[0].value
    }

    setDropdownValues((prevState) => ({
      ...prevState,
      assignComponent: assigneComponentValue,
      majcom: majcomValue,
      section: sectionValue,
      squadron: squadronValue
    }))

  }, [
    assignedComponentOptions, 
    initialSectionOptions, 
    initialMajcomOptions, 
    initialSquadronOptions
  ])



  useEffect(() => {
    setAnnouncements(AnnouncementData)
  }, [AnnouncementData])

  useEffect(() => {
    async function getAccordionData() {
      if (announcements.length > 0 || refresh) {
        setShowPageOverlay(true)

        await getBlobStorage(Announcementslist, announcements).then((data) => {
          const accordionItem =
          data?.filter((accordion: Announcement) => {
              if (Object.keys(accordion).length > 0) {
                return (assignedComponentOptions.some((e) =>
                  e.value === accordion.AssignedComponentCode || 
                (!accordion.AssignedComponentCode && dropdownValues.assignComponent === -1)
                ) || dropdownValues.assignComponent === accordion.AssignedComponentCode) && 
                majcomOptions.some((e) =>
                  ((e.value === accordion.ServicingMAJCOMCode &&
                    e.assignedComponentCode === accordion.AssignedComponentCode) || 
                    (!accordion.ServicingMAJCOMCode && dropdownValues.majcom === -1))
                ) && initialSquadronOptions.some((e) => (e.value !== '' && e.value === accordion?.Squadron) || 
                  (accordion?.Squadron === '' && accordion?.Squadron === dropdownValues.squadron)
                  || dropdownValues.squadron === accordion.Squadron)
                && ((accordion?.SectionCodes?.length <= 0 && dropdownValues.section === -1)  || 
                accordion?.SectionCodes?.length >= 1 && accordion?.SectionCodes?.every((section) =>
                  initialSectionOptions.some(e => e.value === section))
                )
              } else {
                return
              }
            })?.map(
              (accordion: Announcement) => {
                return {
                  AssignedComponent: accordion.AssignedComponent,
                  AssignedComponentCode: accordion.AssignedComponentCode,
                  Attachments: accordion.Attachments,
                  Category: accordion.Category.length === 0  ? 'All' : accordion.Category.join(', '),
                  CategoryCodes: accordion.CategoryCodes,
                  Description: accordion.Description,
                  ExpirationDate: new Date(accordion.ExpirationDate as string)
                    .toISOString().substring(0, 10),
                  ExpiryDate: new Date(accordion.ExpirationDate as string)
                    .toISOString().substring(0, 10),
                  Id: accordion.eKey,
                  IsArchived: accordion.IsArchived,
                  Section: accordion.Section.length === 0  ? 'All' : accordion.Section.join(', '),
                  SectionCodes: accordion.SectionCodes,
                  ServicingMAJCOM: accordion.ServicingMAJCOM,
                  ServicingMAJCOMCode: accordion.ServicingMAJCOMCode,
                  ServicingOrganization: accordion.Squadron === '' ? 'All' : accordion.Squadron,
                  Tags: accordion.Tags,
                  Title: accordion.Title,
                  eKey: accordion.eKey,
                  eTag: accordion.eTag
                }
              }) || []
              
          newAccordions(dropdownValues.assignComponent,
            dropdownValues.majcom,
            dropdownValues.section,
            dropdownValues.squadron,
            accordionItem
          )
          setAccordionItems(accordionItem)
          setShowPageOverlay(false)
        })
      }
    }
    getAccordionData()
  }, [announcements, refresh, assignedComponentOptions, majcomOptions, sectionOptions, 
    squadronOptions])

  return (
    <div className='row m-0'>
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1 breakall'
          cancel='Cancel'
          className='alert-info'
          message={DELETE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showPageOverlay && <PageOverlayBusy />}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center flex-wrap settingsfilters'>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='AssignComponent'
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignComponentChange}
                options={assignedComponentOptions}
                value={dropdownValues.assignComponent}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingMAJCOM'
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMajcomChange}
                options={majcomOptions}
                value={dropdownValues.majcom}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='ServicingOrganization'
                label='Servicing Organization'
                name='Servicing Organization'
                onChange={onSquadronChange}
                options={squadronOptions}
                value={dropdownValues.squadron}
              />
            </div>
            <div className='mx-2 my-sm-2'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11 title-color41 '
                id='Section'
                label='Section'
                name='Section'
                onChange={onSectionChange}
                options={sectionOptions}
                value={dropdownValues.section}
              />
            </div>
            <div className='dividerdashed vertical mx-1 mx-lg-2 d-none d-md-block'></div>
            <div className='ms-2 ms-sm-auto my-sm-2'>
              <Buttons
                aria-label='ADD'
                className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold settingsaddbtn'
                icon='icon-add me-xl-1 font-11'
                label='ADD'
                onClick={() => {
                  onAdd()
                }}
              />
            </div>
          </div>
        }
        name='Announcements'
      />
      <div className='p-0  mt-2 settings-main customaccrdionactive'>
        {showAddPopup && (
          <AddEditView
            addOrEdit='Add'
            announcements={announcements}
            assignComponents={assignComponents}
            assignedComponentOptions={assignedComponentOptions}
            cancel={onCancel}
            categories={categories}
            filtersvalue={addEditValue}
            initialMajcomOptions={initialMajcomOptions}
            initialSectionOptions={initialSectionOptions}
            initialSquadronOptions={initialSquadronOptions}
            majcoms={majcoms}
            refresh={refresh}
            roleContext={roleContext}
            sectionOption={sectionOptions}
            sections={sections}
            setAnnouncements={setAnnouncements}
            setRefresh={setRefresh}
            showAddPopup={showAddPopup}
            visibleSquadrons={visibleSquadrons}
          />
        )}

        {filterAccordionItems && filterAccordionItems?.length === 0 ? (
         <div>
          <NO_RESULTS/>
          </div>
        ) : (
          <Accordions
            IsEdit={showEditPopup}
            ItemId={inEditMode?.rowKey}
            accordionitemclass='shadow card mb-2 my-2 mx-2'
            actions={[
              {
                activeClass:
                  'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto bgcolor-primary whitetext text-nowrap sourcesansprosemibold',
                alabel: 'Edit',
                className:
                  'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold',
                icon: 'icon-pencil me-xl-1 font-10',
                label: 'Edit',
                onClick: onEdit,
              },
              {
                alabel: 'Delete',
                className:
                  'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold',
                icon: 'icon-trashbin me-xl-1 font-10',
                label: 'Delete',
                onClick: onDelete,
              },
            ]}
            className='accordions'
            count='bordered px-1 ms-1 border-radius'
            dataobj={onAccordions}
            defaultActivekey='1'
            dividerClass='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'
            extrasClass='d-flex flex-column flex-md-row flex-wrap w-100'
            headerextras={[
              { classq: 'me-auto my-2 col', name: 'Title' },
              {
                classq: 'w-100 min-w-md-150 max-w-150 my-2',
                name: 'AssignedComponent',
              },
              {
                classq: 'w-100 min-w-md-120 max-w-120 my-2',
                name: 'ServicingMAJCOM',
              },
              {
                classq: 'w-100 min-w-md-120 max-w-120 my-2',
                name: 'ServicingOrganization',
              },
              { classq: 'w-100 min-w-md-150 max-w-150 my-2', name: 'Section' },
              { classq: 'w-100 min-w-md-100 max-w-100 my-2', name: 'Category' },
              { classq: 'text-nowrap w-100 max-w-80 my-2', name: 'IsArchived' },
            ]}
            inputProps={{
              accordionheadClass: 'd-flex align-items-center px-2 py-3 custombg',
              className: 'justify-content-start poppins-medium font-13 w-100 p-0',
              contentclassName: 'p-0',
            }}
            isSettings={true}
            items={filterAccordionItems}
            renderHtml={accordionContent}
            titleIcon='icon-minusform font-16 color-primary pe-2'
            titleclassName='title-color35 poppins-semibold font-12'
            titlecollapsedIcon='icon-plusform pe-2 font-16 color-primary'
            titlecontentclassName='poppins-semibold font-12 title-color2 lineClamp2 pe-2 breakall'
          />
        )}
      </div>
    </div>
  )
}
export default SettingsAnnouncements
